import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import getOrganismos from '../../graphql/querys/organismos/getOrganismosFast.graphql';
import { Col, Row, Select, Tooltip, Skeleton } from 'antd';
import * as Icons from '@ant-design/icons';
import _ from 'lodash';

const SelectorOrganismo = props => {
  // eslint-disable-next-line no-unused-vars
  const { data, loading, error } = useQuery(getOrganismos, {
    fetchPolicy: 'network-only',
  });

  const onChangeOrganismo = idOrganismo => {
    props.onChangeOrganismo(idOrganismo);
  };

  if (loading) {
    return (
      <Row>
        <Col span={16} offset={4}>
          <Skeleton.Input style={{ width: 200 }} active={true} />
        </Col>
      </Row>
    );
  }

  const usuario = _.get(props, 'usuario', {});

  return (
    <Row>
      <Col span={4} offset={4}>
        <>
          <span style={{ fontSize: 18, fontWeight: 'bold' }}> Organismo </span>
          <Tooltip
            title="Seleccione el organismo del reporte"
            style={{ marginLeft: 10 }}
          >
            <Icons.QuestionCircleOutlined />
          </Tooltip>
        </>
      </Col>
      <Col span={8}>
        <Select
          style={{ width: 415 }}
          id="organismos"
          placeholder="Seleccione el organismo"
          disabled={usuario.rol != 'SUPERVISOR'}
          defaultValue={props.idOrganismo}
          onSelect={valor => onChangeOrganismo(valor)}
        >
          {data.getOrganismos &&
            data.getOrganismos
              .filter(organismo => organismo.nombre.includes('JUZGADO DE PAZ'))
              .map(organismo => (
                <Select.Option key={organismo._id}>
                  {organismo.nombre}
                </Select.Option>
              ))}
        </Select>
      </Col>
    </Row>
  );
};

SelectorOrganismo.propTypes = { onChangeOrganismo: PropTypes.func.isRequired };

export default SelectorOrganismo;
